import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { SectionCTA } from './SectionCTA';
import { faqs } from '../data/content';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-brand-50 px-5 py-16 md:py-24" data-id="element-98" data-mp="1cgb719rq4adk">
      <div className="mx-auto max-w-3xl" data-id="element-99" data-mp="2a178mm2eoyzv">
        <SectionHeading eyebrow="Frequently Asked Questions" title="Everything You Need to Know" data-id="element-100" data-mp="2a05v8axx40ez" />

        <ul className="mt-10 space-y-3" data-id="element-101" data-mp="2512p0n67bo5f">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-brand-100" data-id="element-102" data-mp="1v5hjwg5u67rg" data-mpi={i}>
                <h3 data-id="element-103" data-mp="opfc43rz0z23">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left text-base font-extrabold text-brand-950 focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-500 sm:text-lg" data-id="element-104" data-mp="opp0xo1a5067">
                    {f.q}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-105" data-mp="1fnm0nnkewfa3" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-106" data-mp="s0w06qnposrl">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-107" data-mp="wynrbigj8auq">
                      <p className="px-5 pb-5 text-base leading-relaxed text-brand-900/80" data-id="element-108" data-mp="2kw6pu813u2bo">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <SectionCTA label="Yes, I'm Ready to Get the Roadmap™" data-id="element-109" data-mp="2az20jzbypqqn" />
      </div>
    </section>;
}